const ERROR_MSG_CALCULATED_VALUES =
	'Ocorreu um erro ao tentar calcular os valores.'

export { ERROR_MSG_CALCULATED_VALUES }
